import React, {useEffect} from "react";
import SubTitle from "../../components/SubTitle";
import {useForm, FormProvider, SubmitHandler} from "react-hook-form";
import {useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem, ResponseList} from "../../models/clientModels/interfaces/Response";
import {useNavigate, useParams} from "react-router-dom";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import * as statisticsCategoryApi from "../../api/statisticsApi/statisticsCategoryApi";
import {useQuery, useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import MWProgress from "../../components/MWProgress";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";

import StatisticsCategoryForm from "./StatisticsCategoryForm";
import {
  initializeStatisticsCategory,
  initialStatisticsCategoryListParams,
  WOStatisticsCategory,
} from "../../models/serverModels/workOrder/WOStatisticsCategory";

const statisticsCategorySchema = yup.object({
  categoryName: yup.string().required("카테고리명을 입력해주세요"),
  displayOrder: yup.number(),
});

const UpdateStatisticsCategory = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data, isLoading: isGetLoading} = useQuery(
    ["statisticsCategoryList", {...initialStatisticsCategoryListParams, token: tokenState}],
    () =>
      statisticsCategoryApi.getList({...initialStatisticsCategoryListParams, token: tokenState}),
    {
      select: (data: ResponseList<WOStatisticsCategory>) =>
        data.items?.find((item) => item.uid === parseInt(id!)),
    }
  );

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<WOStatisticsCategory>,
    Params.Update<WOStatisticsCategory>
  >({
    api: statisticsCategoryApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/Statistics");
        queryClient.invalidateQueries("statisticsCategoryList");
      },
    },
  });

  const methods = useForm<WOStatisticsCategory>({
    defaultValues: data || initializeStatisticsCategory,
    resolver: yupResolver(statisticsCategorySchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(data);
  }, [data, reset]);

  const onSubmit: SubmitHandler<WOStatisticsCategory> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeStatisticsCategory, ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="범례내용 분류 편집" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <StatisticsCategoryForm captionColor="#546E7A" />
            <ConfirmButtonGroup link="/Statistics" cancelText="취소" confirmText="수정" />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateStatisticsCategory;
